import { InboxOutlined } from '@ant-design/icons';
import { Alert, Upload } from 'antd';
import {
  getMessageMediaConstraint,
  MediaValidationErrorCode,
  MessageMediaConstraintKey,
  validateMessageMediaFile
} from 'constants/mediaConstraints';
import { useState } from 'react';
import { bytesToSize } from 'utils/utils';

type AllProps = {
  mediaConstraintKey: MessageMediaConstraintKey;
  onSelectFile: (file: File) => void;
  helpText?: string;
};

const buildValidationMessage = (
  errorCode: MediaValidationErrorCode,
  maxFileSize: number
): string => {
  if (errorCode === 'file_too_large') {
    return `File size should be less than ${bytesToSize(maxFileSize)}.`;
  }

  return 'Unsupported file type.';
};

function UploadArea({ mediaConstraintKey, onSelectFile, helpText }: AllProps) {
  const [errorMessage, setErrorMessage] = useState('');
  const mediaConstraint = getMessageMediaConstraint(mediaConstraintKey);

  return (
    <>
      {errorMessage && (
        <>
          <Alert message={errorMessage} type="error" showIcon />
        </>
      )}
      <div className="create-message-component-title">
        {helpText || 'Drag and Drop your file or create your message.'}
      </div>
      <Upload.Dragger
        accept={mediaConstraint.accept}
        showUploadList={false}
        beforeUpload={async (file) => {
          setErrorMessage('');

          const validationResult = await validateMessageMediaFile(file, mediaConstraintKey);
          if (!validationResult.isValid) {
            setErrorMessage(
              buildValidationMessage(validationResult.errorCode, mediaConstraint.maxFileSize)
            );
            return false;
          }

          onSelectFile(file);
          return false;
        }}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
        <p className="ant-upload-hint">Drop file here that you wish to send as a message</p>
        <p className="ant-upload-hint">Allowed file size is {bytesToSize(mediaConstraint.maxFileSize)}</p>
      </Upload.Dragger>
    </>
  );
}

export default UploadArea;
